const destinationDetails = {
    overview: 'Overview',
    pointsOfInterest: 'Points of Interest',
    activities: 'Activities',
    gallery: 'Gallery',
    map: 'Map',
    bookYourExperience: 'Book Your Experience',
    discoverOurTrips: 'Discover our trips that include',
    wantToVisit: 'Want to visit this destination?',
    contactUsForTrip: 'Contact us to organize your personalized trip.',
    requestQuote: 'Request Quote',
    breadcrumbDestinations: 'Destinations',
    breadcrumbActivities: 'Activities',
    cornoGrande: 'Corno Grande - The Highest Peak',
    campoImperatore: 'Campo Imperatore - The "Little Tibet"',
    rifugioDuca: 'Duca degli Abruzzi Refuge',
    sentieroCentenario: 'Centenary Trail',
    vistaPanoramica: 'Panoramic view of all Abruzzo',
    // Destination descriptions
    granSassoDescription: 'Gran Sasso d\'Italia is the highest peak of the continental Apennines, reaching 2,912 meters in height. This majestic mountain offers breathtaking landscapes, hiking trails for all levels, and the possibility of practicing winter sports during the cold season.',
    granSassoSubtitle: 'The Giant of the Apennines',
    roccaCalascioDescription: 'In the heart of the Gran Sasso and Monti della Laga National Park, Rocca Calascio is one of the most suggestive villages in Abruzzo. Located at over 1,400 meters above sea level, this small gem offers breathtaking views and a timeless atmosphere. The village, now semi-abandoned, preserves a unique charm among stone ruins, silence, and infinite panoramas over the Abruzzo mountains. A perfect place for those seeking authenticity, beauty, and a deep connection with nature and history.',
    roccaCalascioSubtitle: 'The Village in the Clouds',
    collaltoSabinoDescription: 'Perched on a hill among the woods and hills of Sabina, Collalto Sabino is one of the most beautiful villages in Italy, rich in medieval charm and breathtaking panoramas. Stone walls, towers, narrow alleys, and a perfectly preserved castle make it an unmissable stop for those seeking authenticity, history, and beauty off the beaten tourist path. A place where time seems to have stopped, ideal for a relaxing walk and to immerse yourself in the magic of an intimate and hidden Italy.',
    collaltoSabinoSubtitle: 'The Medieval Village of Sabina',
    santoStefanoDiSessanioDescription: 'In the heart of the Gran Sasso National Park, Santo Stefano di Sessanio is one of the most fascinating villages in Abruzzo. A small medieval gem in white limestone, perfectly integrated into the surrounding mountain landscape. Carefully restored, the village has maintained its ancient soul intact, becoming a symbol of slow and sustainable tourism. A place where every step tells a story and every corner invites contemplation.',
    santoStefanoDiSessanioSubtitle: 'The Medieval Gem of Gran Sasso',
    trabocchiCoastDescription: 'The Costa dei Trabocchi is one of the most suggestive stretches of the Adriatic coast, characterized by ancient wooden fishing structures that extend over the sea like sleeping giants. This coast, which stretches for about 70 kilometers between Ortona and Vasto, offers a unique landscape where history, tradition, and nature merge in perfect harmony. The trabocchi, ancient fishing machines dating back to the 18th century, are today symbols of a maritime art that resists time, surrounded by unspoiled beaches, hidden coves, and breathtaking views of the crystal-clear sea.',
    trabocchiCoastSubtitle: 'The Enchanted Coast of the Trabocchi',
    // Rocca Calascio points of interest
    castelloRoccaCalascio: 'Rocca Calascio Castle - Among the highest castles in Italy',
    chiesaSantaMaria: 'Church of Santa Maria della Pietà - 17th century octagonal gem',
    vistaPanoramica360: '360-degree panoramic view',
    borgoMedievale: 'Semi-abandoned medieval village',
    sentieriPanoramici: 'Panoramic trails in the mountains',
    // Alba Fucens points of interest
    anfiteatroRomano: 'Roman Amphitheater - One of the best preserved in central Italy',
    chiesaSanPietro: 'Church of San Pietro - Built on the remains of a pagan temple',
    vestigiaRomane: 'Roman ruins and cobblestone streets',
    panoramiMonteVelino: 'Views of Monte Velino',
    sitoArcheologico: 'National archaeological site',
    // Activities
    mountainExcursions: 'Mountain excursions',
    rockClimbing: 'Rock climbing',
    wildlifeObservation: 'Wildlife observation',
    alpineCrossCountrySkiing: 'Alpine and cross-country skiing',
    naturePhotography: 'Nature photography',
    // Rocca Calascio specific activities
    panoramicWalk: 'Panoramic walk in the medieval village',
    castleVisit: 'Visit to the castle and church',
    landscapePhotography: 'Landscape photography',
    culturalImmersion: 'Immersion in local history and culture',
    // Alba Fucens specific activities
    archaeologicalWalk: 'Archaeological walk among the ruins',
    amphitheaterVisit: 'Visit to the Roman amphitheater',
    churchExploration: 'Exploration of the Church of San Pietro',
    archaeologicalPhotography: 'Archaeological and landscape photography',
    romanHistoryImmersion: 'Immersion in Roman history',
    // Pescasseroli specific activities
    historicCenterWalk: 'Relaxing walk in the historic center',
    nationalParkExploration: 'Exploration of the National Park',
    localProductsDiscovery: 'Discovery of typical local products',
    abruzzoCultureImmersion: 'Immersion in Abruzzo culture',
    // Rocca di Mezzo specific activities
    villageCenterWalk: 'Walk in the village center',
    historicStreetsExploration: 'Exploration of historic streets and squares',
    plateauTrailsWalk: 'Walk on plateau trails',
    floraFaunaObservation: 'Observation of local flora and fauna',
    mountainRhythmImmersion: 'Immersion in the slow rhythms of the mountains',
    // Collalto Sabino specific activities
    ancientVillageWalk: 'Walk in the ancient village',
    medievalStreetsExploration: 'Exploration of medieval streets',
    panoramicPointsVisit: 'Visit to panoramic points',
    baronialCastleDiscovery: 'Discovery of the baronial castle',
    medievalHistoryImmersion: 'Immersion in medieval history',
    // Santo Stefano di Sessanio specific activities
    medievalVillageWalk: 'Walk in the medieval village',
    narrowStreetsExploration: 'Exploration of narrow streets and squares',
    artisanShopsVisit: 'Visit to artisan shops',
    mediceanTowerClimb: 'Climb to the Medici Tower',
    silentBeautyImmersion: 'Immersion in silent beauty',
    // Villetta Barrea specific activities
    villettaBarreaHistoricCenterWalk: 'Walk in the historic center',
    sunsetDeerWatching: 'Guided sunset excursion for deer spotting',
    villettaBarreaPanoramicTrailsExploration: 'Exploration of panoramic trails',
    villettaBarreaWildlifeObservation: 'Wildlife observation',
    pristineNatureImmersion: 'Immersion in pristine nature',
    // Pescocostanzo specific activities
    culturalHistoricCenterWalk: 'Cultural walk in the historic center',
    noblePalacesExploration: 'Exploration of squares and noble palaces',
    goldsmithTextileShopsVisit: 'Visit to goldsmith and textile shops',
    basilicaSantaMariaDiscovery: 'Discovery of the Basilica of Santa Maria del Colle',
    refinedAtmosphereImmersion: 'Immersion in the refined atmosphere of the village',
    // Costa dei Trabocchi specific activities
    coastalPanoramicWalk: 'Panoramic walk along the coast',
    historicTrabocchiVisit: 'Visit to historic trabocchi',
    boatExcursionAlongCoast: 'Boat excursion along the coast',
    freshFishTasting: 'Fresh fish tasting',
    costaTrabocchiLandscapePhotography: 'Landscape photography'
};

export default destinationDetails;
